import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '@/_shared';
import { apiClient } from '@/_shared';

import type { SubsidyMutationSchema, SubsidyQuerySchema } from './schemas/subsidy-schemas';

export const useCreateMutation = () =>
  useMutation<{ data: SubsidyQuerySchema }, ApiError, SubsidyMutationSchema>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/subsidies',
        payload,
      }),
  });

export const useSubsidyBulkUpdateMutation = () =>
  useMutation<{ data: { id: number } }, ApiError, { items: SubsidyMutationSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/subsidies/bulk-update',
        payload,
      }),
  });

export const useDeleteMutation = () =>
  useMutation<unknown, unknown, { id: number | string }>({
    mutationKey: ['SUBSIDY_DELETE'],
    mutationFn: ({ id }) =>
      apiClient.request({
        endpoint: `/api/v1/subsidies/${id}`,
        method: 'DELETE',
      }),
  });
